module.exports = __webpack_public_path__ + "static/media/t_big_04.827b458e.png";